import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

export default function AuditCoverageBanner({ navigate }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/audit-coverage").then((r) => setData(r.data)).catch(() => setData(null));
  }, []);
  if (!data || !data.persons_with_missing) return null;
  const monthName = (ym) => {
    const [y, m] = ym.split("-");
    const names = ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return `${names[parseInt(m) - 1]} ${y.slice(2)}`;
  };
  const top = (data.rows || []).filter((r) => r.missing_months?.length > 0).slice(0, 5);
  const isCritical = data.total_missing_months >= 10;
  const wrap = isCritical
    ? "alert-banner-red border-2 border-red-500 ring-2 ring-red-300"
    : "alert-banner-orange border-2 border-orange-400";
  return (
    <div className={`card-flat p-4 mb-4 ${wrap}`} data-testid="audit-coverage-banner">
      <div className="flex items-start gap-3">
        <span className="text-3xl leading-none">📋</span>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2 flex-wrap">
            <div>
              <h3 className="font-display font-extrabold text-base uppercase tracking-wider">
                {isCritical ? "🚨 RAPOARTE AUDIT URGENTE — DE GENERAT" : "Rapoarte audit lipsă"}
              </h3>
              <div className="text-xs mt-0.5 opacity-90">
                <strong>{data.total_missing_months}</strong> rapoarte lipsă de la <strong>{data.persons_with_missing}</strong> {data.persons_with_missing === 1 ? "angajat ConVic" : "angajați ConVic"} · ultima lună necesară: <strong>{monthName(data.last_full_month)}</strong>
              </div>
            </div>
            <button
              type="button"
              onClick={() => navigate("/personal")}
              className={`text-xs font-bold px-3 py-1.5 rounded ${isCritical ? "bg-red-700 hover:bg-red-800 text-white" : "bg-orange-700 hover:bg-orange-800 text-white"}`}
              data-testid="audit-coverage-cta"
            >
              Vezi în Personal →
            </button>
          </div>
          {/* TOP 5 persoane cu cele mai multe rapoarte lipsă */}
          <div className="mt-3 space-y-1.5">
            {top.map((r) => (
              <div key={r.person_id} className="flex items-center gap-2 text-xs">
                <span className="font-semibold">{r.name}</span>
                <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold ${isCritical ? "bg-red-200 text-red-900" : "bg-orange-200 text-orange-900"}`}>
                  {r.missing_months.length} {r.missing_months.length === 1 ? "lună" : "luni"}
                </span>
                <span className="text-[10px] opacity-80 truncate">
                  {r.missing_months.slice(0, 4).map(monthName).join(", ")}
                  {r.missing_months.length > 4 && ` +${r.missing_months.length - 4} mai multe`}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
